import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import type { Session } from "../types";

export function ProtectedRoute({
  session,
  children,
}: {
  session: Session | null;
  children: ReactNode;
}) {
  const location = useLocation();

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
